import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import type { HoverLabelTheme } from './types';

export const hoverLabelBaseStyle = css`
  box-shadow: ${theme.shadows.floating};
  font-weight: ${theme.font.weight.bold};
  max-width: 270px;
  padding: ${theme.spacing(1)};
`;

export const hoverLabelThemeStyles: Record<HoverLabelTheme, string> = {
  dark: css`
    background: ${theme.colors.neutral90};
    color: ${theme.colors.white};
  `,
  light: css`
    background: ${theme.colors.white};
    color: ${theme.colors.neutral90};
  `,
};
